/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Gettingstarted_Item21Inputs */

const he_help_gettingstarted_item21 = /** @type {(inputs: Help_Gettingstarted_Item21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזמינו חברי צוות`)
};

const en_help_gettingstarted_item21 = /** @type {(inputs: Help_Gettingstarted_Item21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite team members`)
};

/**
* | output |
* | --- |
* | "Invite team members" |
*
* @param {Help_Gettingstarted_Item21Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const help_gettingstarted_item21 = /** @type {((inputs?: Help_Gettingstarted_Item21Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Gettingstarted_Item21Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_help_gettingstarted_item21(inputs)
	return en_help_gettingstarted_item21(inputs)
});
export { help_gettingstarted_item21 as "help_gettingStarted_item2" }